import VueI18n from 'vue-i18n'
import Vue from 'vue'

const SYSTEM_LANGUAGES_MAP = {
  // 英文
  en: 'en-US',
  'en-US': 'en-US',
  'en-GB': 'en-US',
  'en-AU': 'en-US',
  'en-CA': 'en-US',
  'en-NZ': 'en-US',
  'en-IE': 'en-US',
  'en-ZA': 'en-US',
  'en-BZ': 'en-US',
  'en-JM': 'en-US',
  'en-TT': 'en-US',
  // 中文简体
  zh: 'zh-CN',
  'zh-CN': 'zh-CN',
  'zh-SG': 'zh-CN',
  'zh-HK': 'zh-HK',
  /**
   * 澳门和台湾，用香港繁体代替
   */
  'zh-MO': 'zh-HK',
  'zh-TW': 'zh-HK',
  ja: 'ja-JP',
  'ja-JP': 'ja-JP',
}

let defaultLang = 'zh-CN'

// 1. 如果链接中有lang参数，就使用链接中的lang参数
// 2. 否则使用 cookie 中的 lang 参数
// 3. 否则使用浏览器的默认语言
// 4. 否则使用默认语言 zh-CN
function getLanguage() {
  const urlParams = new URLSearchParams(window.location.search)
  let lang = urlParams.get('lang')
  if (!lang) {
    lang = document.cookie.split('; ').find(row => row.startsWith('lang='))?.split('=')[1]
  }
  if (!lang) {
    lang = navigator.language || navigator.userLanguage
  }
  return SYSTEM_LANGUAGES_MAP[lang] || defaultLang
}

defaultLang = getLanguage()

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: defaultLang,
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': require('./zh-CN.json'),
    'en-US': require('./en-US.json'),
    'zh-HK': require('./zh-HK.json')
  }
})

window.defaultLang = defaultLang
window.$t = i18n.t.bind(i18n)
window.$tc = i18n.tc.bind(i18n)

export default i18n
